// extracted by mini-css-extract-plugin
export default {"homeButton":"SilverLake_homeButton__jO1sw","mapButton":"SilverLake_mapButton__2zvvT","button":"SilverLake_button__6kQF-"};